import { apiClient } from '@/core/infra_api_client'

// ============= Types =============

export interface CostSummary {
  totalCost: number
  currency: string
  period: string
  previousPeriodCost: number
  changePercent: number
}

export interface CostBreakdownItem {
  category: string
  service: string
  cost: number
  currency: string
  usageQuantity?: number
  usageUnit?: string
}

export interface CostBreakdown {
  items: CostBreakdownItem[]
  total: number
  currency: string
  period: string
}

export interface CostTrendPoint {
  date: string
  cost: number
  currency: string
}

export interface CostTrend {
  points: CostTrendPoint[]
  currency: string
  periodStart: string
  periodEnd: string
}

// ============= API =============

const BASE_PATH = 'costs'

export async function getSummary(params?: {
  environmentId?: string
  period?: string
}): Promise<CostSummary> {
  const searchParams: Record<string, string | number | boolean> = {}
  if (params?.environmentId) searchParams['environment_id'] = params.environmentId
  if (params?.period) searchParams['period'] = params.period

  return apiClient.get<CostSummary>(`${BASE_PATH}/summary`, searchParams)
}

export async function getBreakdown(params?: {
  environmentId?: string
  period?: string
  groupBy?: string
}): Promise<CostBreakdown> {
  const searchParams: Record<string, string | number | boolean> = {}
  if (params?.environmentId) searchParams['environment_id'] = params.environmentId
  if (params?.period) searchParams['period'] = params.period
  if (params?.groupBy) searchParams['group_by'] = params.groupBy

  return apiClient.get<CostBreakdown>(`${BASE_PATH}/breakdown`, searchParams)
}

export async function getTrend(params?: {
  environmentId?: string
  periodStart?: string
  periodEnd?: string
  granularity?: string
}): Promise<CostTrend> {
  const searchParams: Record<string, string | number | boolean> = {}
  if (params?.environmentId) searchParams['environment_id'] = params.environmentId
  if (params?.periodStart) searchParams['period_start'] = params.periodStart
  if (params?.periodEnd) searchParams['period_end'] = params.periodEnd
  if (params?.granularity) searchParams['granularity'] = params.granularity

  return apiClient.get<CostTrend>(`${BASE_PATH}/trend`, searchParams)
}
